import { render, staticRenderFns } from "./amount-input.vue?vue&type=template&id=af998c3c&"
import script from "./amount-input.vue?vue&type=script&lang=js&"
export * from "./amount-input.vue?vue&type=script&lang=js&"
import style0 from "./amount-input.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "amount-input.vue"
export default component.exports